import React from 'react';

import AddForm from 'components/forms/AddForm';

const AddPage = () => {
  return <AddForm />;
};

export default AddPage;
